
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14 0C6.277 0 0 6.277 0 14s6.277 14 14 14 14-6.277 14-14S21.723 0 14 0zm1.167 19.833A1.17 1.17 0 0114 21a1.17 1.17 0 01-1.167-1.167v-7A1.17 1.17 0 0114 11.667a1.17 1.17 0 011.167 1.166v7zm-.339-10.838c-.221.21-.525.338-.828.338-.152 0-.303-.035-.443-.093a1.203 1.203 0 01-.385-.245 1.227 1.227 0 01-.339-.828c0-.304.129-.607.339-.829.116-.105.233-.186.385-.245a1.17 1.17 0 011.271.245c.21.222.339.525.339.829 0 .303-.129.606-.339.828z","fill":"#262626"}})])
          )
        }
      }
    